// Generated code; do not edit.
// You might be looking for: packages/bank-schemas/bank.graphql
// To regenerate: yarn workspaces foreach -A run generate-types

import type * as Types from '../../gqltypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { AutofillDataFragmentDoc } from '../../common-queries.generated';
export type EmployeePayMutationVariables = Types.Exact<{
  input: Types.PayInput;
}>;

export type EmployeePayMutation = {
  readonly __typename: 'Mutation';
  readonly pay: {
    readonly __typename: 'PayReply';
    readonly authUrl: string | null;
    readonly paymentFid: string;
  };
};

export type SetAutofillMutationVariables = Types.Exact<{
  accountNumber: Types.Scalars['AccountNumber'];
  desiredAmount: Types.Scalars['Amount'];
}>;

export type SetAutofillMutation = {
  readonly __typename: 'Mutation';
  readonly setAutofill: {
    readonly __typename: 'SetAutofillReply';
    readonly cardAccount: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly balanceNok: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
      readonly autofill: {
        readonly __typename: 'Autofill';
        readonly desiredAmount: string;
        readonly lowLimit: string;
        readonly dailyLimit: string;
        readonly isDailyLimitReached: boolean;
      } | null;
    };
    readonly operationalAccount: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly balanceNok: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
    };
  };
};

export const EmployeePayDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EmployeePay' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PayInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pay' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'payInput' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'authUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentFid' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmployeePayMutation, EmployeePayMutationVariables>;
export const SetAutofillDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetAutofill' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountNumber' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AccountNumber' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'desiredAmount' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Amount' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setAutofill' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountNumber' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountNumber' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'desiredAmount' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'desiredAmount' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cardAccount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutofillData' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operationalAccount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'balanceNok' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'asNumber' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AutofillDataFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<SetAutofillMutation, SetAutofillMutationVariables>;
